import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { patchState, signalState } from '@ngrx/signals';
import { AppConfigService } from '../../../services/app-config.service';

export interface AboutDialogData {
    platformVersion: string;
    appVersion: string;
    build: string;
}
@Component({
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.scss'],
    imports: [MatDialogContent]
})
export class AboutDialogComponent implements OnInit {
    private dialogRef = inject<MatDialogRef<AboutDialogComponent>>(MatDialogRef);
    private config = inject(AppConfigService);

    public readonly state = signalState<AboutDialogData>({
        platformVersion: '',
        appVersion: '',
        build: ''
    });

    public ngOnInit(): void {
        this.init();
    }

    public get currentYear(): number {
        return new Date().getFullYear();
    }

    public close(): void {
        this.dialogRef.close();
    }

    private init(): void {
        patchState(this.state, {
            platformVersion: this.config.platformVersion,
            appVersion: this.config.appVersion,
            build: this.config.build
        });
    }
}
